if (!customElements.get('size-guide-tabs')) {
  customElements.define(
    'size-guide-tabs',
    class SizeGuideTabs extends HTMLElement {
      constructor() {
        super();
        this.list = this.querySelector('[role="tablist"]');
        this.tabs = Array.from(this.list.querySelectorAll('[role="tab"]'));
        this.panels = this.tabs.map((tab) => this.querySelector(`#${tab.getAttribute('aria-controls')}`));

        // Unselected guides arrive in <template>; lift each out once so switching only moves nodes.
        this.stashed = this.panels.map((panel) => {
          const template = panel.querySelector(':scope > template');
          if (!template) return null;
          template.remove();
          return template.content;
        });

        this.list.addEventListener('click', (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab) this.select(tab);
        });
        this.list.addEventListener('keydown', this.onKeyDown.bind(this));
      }

      onKeyDown(event) {
        const index = this.tabs.indexOf(event.target);
        if (index === -1) return;

        const last = this.tabs.length - 1;
        const next = {
          ArrowRight: index === last ? 0 : index + 1,
          ArrowLeft: index === 0 ? last : index - 1,
          Home: 0,
          End: last,
        }[event.key];
        if (next === undefined) return;

        event.preventDefault();
        this.select(this.tabs[next]);
      }

      select(tab) {
        tab.focus();
        if (tab.getAttribute('aria-selected') === 'true') return;

        this.tabs.forEach((current, index) => {
          const selected = current === tab;
          const panel = this.panels[index];

          current.setAttribute('aria-selected', selected);
          current.tabIndex = selected ? 0 : -1;
          panel.hidden = !selected;

          if (selected) {
            panel.tabIndex = 0;
            panel.append(this.stashed[index]);
            this.stashed[index] = null;
            return;
          }

          panel.removeAttribute('tabindex');
          // Only the guide just closed is still live. Keep it out of the document, so the
          // focus trap never lands in a hidden guide.
          if (!this.stashed[index]) {
            this.stashed[index] = document.createDocumentFragment();
            this.stashed[index].append(...panel.childNodes);
          }
        });

        // The tab row stays pinned while the guide scrolls; bring the new guide's start up under it.
        const panel = this.panels[this.tabs.indexOf(tab)];
        const overlap = this.list.getBoundingClientRect().bottom - panel.getBoundingClientRect().top;
        if (overlap > 0) this.closest('[role="dialog"]').scrollTop -= overlap;

        const modal = this.closest('modal-dialog');
        if (modal?.hasAttribute('open')) trapFocus(modal, tab);
      }
    }
  );
}
